import { createSlice } from "@reduxjs/toolkit";
import { MenuItem } from "src/interfaces/menu.interface";
import { UUID } from "src/types/shared.type";

interface MenuItemState {
  menuItems: MenuItem[];
  filteredMenuItems: MenuItem[];
  hasMenuItemId: UUID | null;
}

const initialState : MenuItemState = {
  menuItems: [],  
  filteredMenuItems: [],
  hasMenuItemId: null,
};

const getItemName = (menuItem: MenuItem) =>
  (menuItem.englishName || menuItem.nonEnglishName || "").trim().toLowerCase();

const sortItemsByName = (items: MenuItem[]) =>
  items.slice().sort((previousItem, nextItem) => {
    const previousName = getItemName(previousItem);
    const nextName = getItemName(nextItem);
    const nameCompare = previousName.localeCompare(nextName);

    if (nameCompare !== 0) return nameCompare;

    return (previousItem.correlationId || "").localeCompare(
      nextItem.correlationId || ""
    );
  });

export const menuItemSlice = createSlice({
  name: "menuItem",
  initialState,
  reducers: {
    set_menu_items: (state, { payload }) => {
      const orderedItems = sortItemsByName(payload.categoryItems ?? []);

      state.menuItems = orderedItems;
      state.filteredMenuItems = orderedItems;
    },
    search_menu_items: (state, { payload }) => {
      const query = payload.toLowerCase();

      state.filteredMenuItems = sortItemsByName(
        state.menuItems.filter((menuItem: MenuItem) =>
          getItemName(menuItem).includes(query)
        )
      );
    },
    delete_menu_item_modal: (state, { payload }) => {
      state.hasMenuItemId = payload;
    },
    sort_menu_items: (state, { payload }) => {
      if (payload === 'aToZ') {
        state.filteredMenuItems = sortItemsByName(state.menuItems);
      } else if (payload === 'zToA') {
        state.filteredMenuItems = sortItemsByName(state.menuItems).reverse();
      }
    },
  },
});

export const { set_menu_items, search_menu_items, delete_menu_item_modal, sort_menu_items } = menuItemSlice.actions;

export default menuItemSlice.reducer;
